import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { LinkableTextArea } from 'components/LinkableTextArea/LinkableTextArea';

interface OwnProps {
  highlights: string[];
}

type Props = OwnProps;

export const Highlights = ({ highlights }: Props) => {
  const { t } = useTranslation();

  return (
    <ul className="c-point">
      {highlights.map((highlight, idx) => (
        <li key={highlight} className="c-point__item">
          <p className="c-point__item__title">
            {t('Highlight #{{highlightNumber}}', {
              highlightNumber: idx + 1,
            })}
          </p>
          <p className="c-point__item__body">
            <LinkableTextArea>{highlight}</LinkableTextArea>
          </p>
        </li>
      ))}
    </ul>
  );
};
